<script setup lang="ts">
import CaseMarkdownWrapper from '@/sharedComponents/CaseMarkdownWrapper.vue'
import MarkdownEditor from '@/sharedComponents/MarkdownEditor/MarkdownEditor.vue'

/**
 * Wrapper for markdown editor when it's used to render markdown in case message bubbles.
 * Overrides the default markdown editor visuals using tailwind classes.
 */

defineProps<{ markdown: string }>()
</script>

<template>
  <CaseMarkdownWrapper>
    <MarkdownEditor
      :value="markdown"
      readonly
    />
  </CaseMarkdownWrapper>
</template>
